export default __webpack_public_path__ + "static/Logo-Binance-Coin-befeeadf2285f56964e71f9d5bc8a809.png";